import type { Signal } from '../../../signals';

import type { _InternalMerge } from './UnionToIntersection';

export type Mutable<T> = {
  -readonly [P in keyof T]: T[P];
};

export type SignalHash = Record<string, Signal<(...args: unknown[]) => void>>;

export type TypedArray =
  | Int8Array
  | Uint8Array
  | Uint8ClampedArray
  | Int16Array
  | Uint16Array
  | Int32Array
  | Uint32Array
  | Float32Array
  | Float64Array
  | number[];

export type FixedNumberArray<L extends number> = ([number, ...number[]] & {
  length: L;
}) &
  TypedArray;

/** Removes any key that is value is undefined from the object */
export type RemovedUndefined<T> = {
  [P in keyof T as T[P] extends undefined ? never : P]: T[P];
};

/** Flatten the type output to improve type hints shown in editors.
 * E.g type Props = Simplify\<PositionProps & SizeProps\>;
 */
export type Simplify<T> = { [KeyType in keyof T]: T[KeyType] };

/** Takes two objects and merges them together */
export type Merge<T extends object> = _InternalMerge<T, {}>;
